import React from "react"

const HeaderNav = ({children}) => {
  return (
    <div className="header-nav">
      <ul className="flex text-white justify-end h-5 mt-2 whitespace-no-wrap">
        {children}
      </ul>
    </div>
  )
}

export default HeaderNav
